import React from 'react';
import {Button, Paper, Typography} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useAnalytics} from 'components/analytics/analytics';
import {AnalyticsEvents} from 'components/analytics/analyticsEvents';
import {LocationService} from 'components/Location/LocationService';
import './FitAppDownloadCard.css';

const FIT_APP_DOWNLOAD_URL = 'https://trackunit.com/trackunit-fit';
const TABLET_LANDSCAPE_MAX_WIDTH = 1024;

interface FitAppDownloadCardProps {
    hasStartedDeviceLookup: boolean;
}

export const FitAppDownloadCard: React.FC<FitAppDownloadCardProps> = props => {
    const analytics = useAnalytics();
    const isPhoneOrTablet = useMediaQuery(`(max-width: ${TABLET_LANDSCAPE_MAX_WIDTH}px) and (pointer: coarse)`);

    if (!isPhoneOrTablet || props.hasStartedDeviceLookup || LocationService.isManitou()) {
        return null;
    }

    return (
        <Paper className="fitAppDownloadCard">
          <Typography variant="h6" component="h2" gutterBottom>
            Start with the Trackunit Fit app
          </Typography>
          <Typography variant="body2" gutterBottom>
            Validate device installs from your phone.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            href={FIT_APP_DOWNLOAD_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analytics.logEvent(AnalyticsEvents.FitAppDownloadClicked, {})}
          >
            Download
          </Button>
        </Paper>
    );
};
